export default {
    setWealthplanNotes(state, payload) {
        state.wealthplan.notes = payload;
    },
    resetWealthplanNotes(state) {
        state.wealthplan.notes = null;
    },
};
